import React, { ReactElement } from 'react';
import { Form, Select } from 'antd';

import { ContentItemBase } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { testId } from 'pricing/utilities/test/dataTestId';

interface Props {
  disabled?: boolean;
}

function FieldContractTermTypes(props: Props): ReactElement {
  const { disabled } = props;

  return (
    <Form.Item
      label="Term Type"
      name="breederContractTermTypeId"
      labelCol={{ span: 15 }}
      wrapperCol={{ span: 15 }}
      rules={[{ required: true, message: 'This field is required' }]}
    >
      <Select
        data-testid={testId.fieldContractTermTypes}
        placeholder="Select"
        disabled={disabled}
      >
        {pricingContent?.contractTermTypes?.map((termType: ContentItemBase) => (
          <Select.Option
            data-testid={testId.fieldContractTermTypeOption}
            key={termType.id}
            value={termType.id}
          >
            {termType.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default FieldContractTermTypes;
